// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M24 20V4H0V20H24ZM15.5029 8H17.5029V12.585L19.0029 11.085L20.417 12.499L16.5029 16.4141L12.5859 12.4971L14 11.083L15.5029 12.5859V8ZM4 8H10C11.1046 8 12 8.89543 12 10V16H10V10H9V16H7V10H6V16H4V8Z"}}]};

const LogoMarkdownFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-markdown-filled',
    ref,
    icon: element,
  },
));

LogoMarkdownFilledIcon.displayName = 'LogoMarkdownFilledIcon';

export default LogoMarkdownFilledIcon;
